<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useUiStore } from '@/stores/ui'
import AppShell from '@/components/layout/AppShell.vue'
import ReauthDialog from '@/components/capabilities/ReauthDialog.vue'
import OToastHost from '@/components/ui/OToastHost.vue'

/**
 * The application root.
 *
 * The re-auth dialog and the toast host are mounted once, here, rather than per screen. The
 * dialog in particular: it is a security control (design §11.4), and a control with several
 * copies has several chances to be the wrong one.
 */

const route = useRoute()
const ui = useUiStore()

/** The login screen is deliberately chrome-less — no navigation to a session that does not exist. */
const withChrome = computed(() => route.meta.chrome !== false)

onMounted(() => {
  ui.applyTheme()
})
</script>

<template>
  <AppShell v-if="withChrome">
    <RouterView v-slot="{ Component }">
      <component :is="Component" />
    </RouterView>
  </AppShell>

  <RouterView v-else v-slot="{ Component }">
    <component :is="Component" />
  </RouterView>

  <ReauthDialog />
  <OToastHost />
</template>
